import type { Combobox as MantineCombobox } from '@mantine/core';

import styled, { css } from 'styled-components';

export const injectDefaultDropdownSelectorStyles = (Dropdown: typeof MantineCombobox.Dropdown) => {
  return styled(Dropdown)`
    .mantine-Combobox-option {
      &:hover {
        background-color: ${({ theme }) => theme.mantineColors.navy[2]};
      }

      &[data-combobox-active='true'] {
        background-color: ${({ theme }) => theme.mantineColors.blue[2]};
      }
    }

    & .mantine-Combobox-input {
      //border: none !important;
      height: 38px;
      border-radius: 6px 6px 0 0;
      margin: unset;
      //border-bottom: 1px solid ${({ theme }) => theme.mantineColors.gray[4]} !important;
    }
  `;
};

export const injectDefaultOptionStyles = (option: typeof MantineCombobox.Option) => {
  return styled(option)`
    padding: 10px 16px;
    line-height: 18px;
    ${({ theme }) => css`
      font-size: 14px;
      font-weight: 400;
      color: ${theme.mantineColors.gray[8]};
    `}
  `;
};
